import React from 'react'
import PropTypes from 'prop-types'

import {HeartIcon, HeartSolidIcon} from '../icons'
import {
    Text,
    IconButton,
    useBreakpointValue,
    Spinner,
    useMultiStyleConfig
} from '@salesforce/retail-react-app/app/components/shared/ui'
import withRegistration from '../with-registration'
import {useIntl} from 'react-intl'

const IconButtonWithRegistration = withRegistration(IconButton, {isWishlistAction: true})

const ProductLikes = ({
    isFavourite = false,
    wishlistCount,
    isHovered = false,
    onFavouriteToggle,
    productName = 'product',
    isLoadingFreshLikes,
    wishlistProductId,
    variant
}) => {
    const intl = useIntl()
    const isDesktop = useBreakpointValue({base: false, lg: true})
    const styles = useMultiStyleConfig('ProductLikes', {isHovered, isDesktop, isFavourite, variant})

    const handleClick = (e) => {
        e?.preventDefault?.()
        e?.stopPropagation?.()
        if (onFavouriteToggle) {
            onFavouriteToggle(!isFavourite)
        }
    }

    return (
        <>
            {isLoadingFreshLikes ? (
                <Spinner size="xs" {...styles.spinner} />
            ) : (
                <>
                    <IconButtonWithRegistration
                        wishlistProductId={wishlistProductId}
                        data-testid="product-likes-button"
                        {...styles.button}
                        aria-label={
                            isFavourite
                                ? intl.formatMessage(
                                    {
                                        id: 'product_tile.assistive_msg.remove_from_wishlist',
                                        defaultMessage: 'Remove {product} from wishlist'
                                    },
                                    {product: productName}
                                )
                                : intl.formatMessage(
                                    {
                                        id: 'product_tile.assistive_msg.add_to_wishlist',
                                        defaultMessage: 'Add {product} to wishlist'
                                    },
                                    {product: productName}
                                )
                        }
                        icon={
                            isFavourite ? (
                                <HeartSolidIcon {...styles.iconSolid} />
                            ) : (
                                <HeartIcon {...styles.iconOutline} />
                            )
                        }
                        onClick={handleClick}
                    />
                    <Text {...styles.count}>{wishlistCount || 0}</Text>
                </>
            )}
        </>
    )
}

ProductLikes.propTypes = {
    isFavourite: PropTypes.bool,
    wishlistCount: PropTypes.number,
    isHovered: PropTypes.bool,
    onFavouriteToggle: PropTypes.func,
    productName: PropTypes.string,
    wishlistProductId: PropTypes.string,
    variant: PropTypes.string
}

export default ProductLikes
